/*
* 模块：Vue注册全局函数
* */
export default {
  install: (Vue, options) => {
    // 根据权限，匹配路由
    Vue.prototype.matchPermission = (routes, permission) => {
      const newRootes = routes // []
      // for (let i = 0, len = permission.length; i < len; i++) {
      //   const _permission = permission[i]
      //   for (let j = 0, len = routes.length; j < len; j++) {
      //     const _route = routes[j]
      //     if (_permission.functionName === _route.name) {
      //       newRootes.push(_route)
      //       break
      //     }
      //   }
      // }
      return newRootes || []
    }
  }
}
